// Styles
import { makeStyles } from "@fluentui/react-components";
import { tokens } from "@fluentui/react-theme";
// Utilities
import { flexParent, flexParentCenterCrossAxis, flexChildSizeFixed } from "@ms/planner-generic-controls/lib/local/utilities/Mixin.styles";
export const useSwitchViewDropdownStyles = makeStyles({
    root: {
        position: "relative",
        ...flexChildSizeFixed("auto"),
        height: tokens.spacingVerticalXXXL
    },
    option: {
        ...flexParent(),
        ...flexParentCenterCrossAxis,
        ":active, :hover": {
            backgroundColor: "transparent"
        }
    },
    unselectedOption: {
        marginLeft: tokens.spacingHorizontalXXL
    },
    dropdown: {
        border: "unset",
        background: "transparent",
        margin: `${tokens.spacingVerticalM} ${tokens.spacingHorizontalXXL} 0px ${tokens.spacingHorizontalXS}`,
        ":active, :hover": {
            backgroundColor: tokens.colorNeutralBackground3
        }
    },
    title: {
        border: "unset",
        background: "transparent",
        color: tokens.colorBrandForeground1,
        fontWeight: tokens.fontWeightSemibold
    },
    icon: {
        marginRight: tokens.spacingHorizontalS,
        fontSize: tokens.fontSizeBase500
    }
});
